import React from "react";
import Navbar from "components/Navbar";
import Footer from "components/Footer";
import { useSelector } from 'react-redux';
import MobileNavbar from "components/MobileNavbar";
import MobileFooter from "components/MobileFooter";
import Teams from "components/AboutUs/Teams";


function AboutUs () {
    const isMobile = useSelector(state=> state.windowSize.isMobile);
    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbar />
            <Teams />
            <MobileFooter />
            </>
        ) : (
            <>
            <Navbar />
            <Teams />
            <Footer />
            </>
        )}
        </>
    )
};

export default AboutUs